import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { FormControl } from '@angular/forms';
import { RTL } from 'src/app/@theme/const';
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import { FieldDictionaryListService } from 'src/app/tabms/services/global/field-dictionary-list.service';
import { ActivatedRoute } from '@angular/router';
import { FieldDictionaryDto } from 'src/app/tabms/models/base/base';
import { TranslateService } from '@ngx-translate/core';
import { PopUpSearchWithoutSqlComponent } from './pop-up-search-without-sql/pop-up-search-without-sql.component';
import { TabConst } from 'src/app/tabms/tab-consts';

@Component({
  selector: 'app-input-pop-up-search',
  templateUrl: './input-pop-up-search.component.html',
  styleUrl: './input-pop-up-search.component.scss'
})
export class InputPopUpSearchComponent implements OnInit, OnDestroy {

  @Input() control: FormControl = new FormControl()
  @Input() fieldName: string
  @Input() service
  @Input() menuKey
  @Input() pageParameters
  @Input({required: true}) searchProperty: string
  @Input() displayedColumns: string[]
  @Input() params
  @Input() size: 'default' | 'compact' | 'xs' = TabConst.DEFAULTSIZE // New input for size control
  @Input() displayValue: string = '';
  @Input() fieldDisplayOn: number = 1
  placeholder: string
  type: string = 'text'
  selectedId: string | null = null
  systemMenuId: string
  currentLang: string
  fieldData: FieldDictionaryDto

  private destroy$: Subject<void> = new Subject<void>();

  @Output() selected = new EventEmitter<string>()

  constructor(
    private dialog: MatDialog,
    private baseService: BaseService,
    private fieldDictionaryListService: FieldDictionaryListService,
    private activatedRoute: ActivatedRoute,
    private themeLayoutService: ThemeLayoutService,
    private translate: TranslateService
  ) {
    this.currentLang = this.baseService.getCurrentLanguage();

    this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe({
      next: (params) => {
        this.systemMenuId = params['id']
      }
    })

    this.themeLayoutService.directionChange.pipe(takeUntil(this.destroy$)).subscribe({
      next: (dir) => {
        (dir === RTL) ? this.currentLang = 'ar' : 'en'
        this.getFieldData();
      }
    })
  }

  ngOnInit(): void {
    this.getFieldData();
  }

  getFieldData() {
    // console.log('this.fieldName', this.fieldName);
    this.fieldDictionaryListService
      .getList()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          if (res && res.length > 0) {
            // console.log(res)
            const pageData = res.find((x) => x.pageid == this.systemMenuId);
            if (!pageData) return
            this.fieldData = pageData.list.find((x) => x.fieldname.toLowerCase() === this.fieldName.toLowerCase());

            const fieldNameTranslation = this.currentLang === 'ar' ?
              this.fieldData?.langvalue.find(x => x.culturename == 'ar-EG')?.value
              : this.fieldData?.langvalue.find(x => x.culturename == this.currentLang)?.value;

            this.placeholder = this.translate.instant('enter') + ' ' + fieldNameTranslation;
            if (!this.fieldData || !fieldNameTranslation) {
              this.placeholder = this.translate.instant('enter') + ' ' + this.translate.instant(this.fieldName);
            }
          }
          else {
            this.placeholder = this.translate.instant('enter') + ' ' + this.translate.instant(this.fieldName);
            // console.log('this.placeholder', this.placeholder);
          }
        }
      });
  }

  popUpShow() {
    if(this.control.disabled) return
    let dialogRef = this.dialog.open(PopUpSearchWithoutSqlComponent, {
      // height: '450px',
      // width: '1100px',
      direction: this.baseService.getDirection(),
      data: { menuKey:this.menuKey, pageParameters: this.pageParameters, service: this.service, displayedColumns: this.displayedColumns, params: this.params
        , fieldDisplayOn: this.fieldDisplayOn
      }
    })

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe({
      next: (selectedRow) => {
        // console.log('The dialog was closed');
        if (selectedRow !== undefined) {
          // console.log(this.searchProperty)
          // console.log(selectedRow[this.searchProperty]);
          const selecteditem = selectedRow._entitydto ? selectedRow._entitydto : selectedRow;
          const selectedValue = selecteditem[this.searchProperty]
          this.control.setValue(selectedValue)
        }
        else {
          this.control.setValue(null)
        }
        this.selected.emit(selectedRow);
      }
    });
  }

  //destroy region
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
